export default __webpack_public_path__ + "static/media/myphoto.4be59075.jpg";